(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : Array.from({
            length: 4
        }, function() {
            return Array(4).fill(0);
        });
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "isPlaying",
            value: function isPlaying() {
                return this.status === "playing";
            }
        },
        {
            key: "processRow",
            value: function processRow(row) {
                var newRow = row.filter(function(num) {
                    return num !== 0;
                });
                var result = [];
                for(var i = 0; i < newRow.length; i++)if (newRow[i] === newRow[i + 1]) {
                    var mergedValue = newRow[i] * 2;
                    result.push(mergedValue);
                    i += 1;
                    this.score += mergedValue;
                } else result.push(newRow[i]);
                while(result.length < 4)result.push(0);
                return result;
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                if (this.board.some(function(row) {
                    return row.includes(2048);
                })) this.status = "win";
            }
        },
        {
            key: "checkLose",
            value: function checkLose() {
                var hasEmpty = this.board.some(function(row) {
                    return row.includes(0);
                });
                if (hasEmpty) return;
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    var current = this.board[row][col];
                    if (col < 3 && current === this.board[row][col + 1]) return;
                    if (row < 3 && current === this.board[row + 1][col]) return;
                }
                this.status = "lose";
            }
        },
        {
            key: "applyMove",
            value: function applyMove(newBoard) {
                var changed = JSON.stringify(newBoard) !== JSON.stringify(this.board);
                if (!changed) return;
                this.board = newBoard;
                this.addRandomTile();
                this.checkWin();
                this.checkLose();
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                if (!this.isPlaying()) return;
                var newBoard = this.board.map(function(row) {
                    return _this.processRow(row);
                });
                this.applyMove(newBoard);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                if (!this.isPlaying()) return;
                var newBoard = this.board.map(function(row) {
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    return _this.processRow(reversed).reverse();
                });
                this.applyMove(newBoard);
            }
        },
        {
            key: "transpose",
            value: function transpose(matrix) {
                var result = [];
                for(var col = 0; col < 4; col++){
                    result[col] = [];
                    for(var row = 0; row < 4; row++)result[col][row] = matrix[row][col];
                }
                return result;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                if (!this.isPlaying()) return;
                var transposed = this.transpose(this.board);
                var moved = transposed.map(function(row) {
                    return _this.processRow(row);
                });
                this.applyMove(this.transpose(moved));
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                if (!this.isPlaying()) return;
                var transposed = this.transpose(this.board);
                var moved = transposed.map(function(row) {
                    var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                    return _this.processRow(reversed).reverse();
                });
                this.applyMove(this.transpose(moved));
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var empty = [];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.board[r][c] === 0) empty.push({
                        r: r,
                        c: c
                    });
                }
                if (!empty.length) return;
                var _empty_Math_floor = empty[Math.floor(Math.random() * empty.length)], r1 = _empty_Math_floor.r, c1 = _empty_Math_floor.c;
                this.board[r1][c1] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = Array.from({
                    length: 4
                }, function() {
                    return Array(4).fill(0);
                });
                this.score = 0;
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.start();
            }
        }
    ]);
    return Game;
}();


"use strict";
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$bestScoreEl = document.querySelector(".best-score");
var $197cd56b15c33885$var$button = document.querySelector(".start");
function $197cd56b15c33885$var$getBest() {
    return Number(localStorage.getItem("bestScore")) || 0;
}
function $197cd56b15c33885$var$setBest(value) {
    localStorage.setItem("bestScore", value);
}
function $197cd56b15c33885$var$render() {
    var prevState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var state = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$bestScoreEl.textContent = $197cd56b15c33885$var$getBest();
    $197cd56b15c33885$var$cells.forEach(function(cell, index) {
        var _prevState_r;
        var r = Math.floor(index / 4);
        var c = index % 4;
        var value = state[r][c];
        var _prevState_r_c;
        var prevValue = (_prevState_r_c = prevState === null || prevState === void 0 ? void 0 : (_prevState_r = prevState[r]) === null || _prevState_r === void 0 ? void 0 : _prevState_r[c]) !== null && _prevState_r_c !== void 0 ? _prevState_r_c : 0;
        cell.textContent = value || "";
        cell.className = "field-cell";
        if (value) cell.classList.add("field-cell--".concat(value));
        if (prevValue === 0 && value) cell.classList.add("new");
        if (value && value === prevValue * 2) cell.classList.add("merge");
        setTimeout(function() {
            cell.classList.remove("new", "merge");
        }, 200);
    });
    $197cd56b15c33885$var$updateMessage();
}
function $197cd56b15c33885$var$updateMessage() {
    var status = $197cd56b15c33885$var$game.getStatus();
    document.querySelector(".message-start").classList.add("hidden");
    document.querySelector(".message-win").classList.add("hidden");
    document.querySelector(".message-lose").classList.add("hidden");
    if (status === "idle") document.querySelector(".message-start").classList.remove("hidden");
    if (status === "win") document.querySelector(".message-win").classList.remove("hidden");
    if (status === "lose") document.querySelector(".message-lose").classList.remove("hidden");
    if (status !== "idle") {
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
    }
}
function $197cd56b15c33885$var$handleMove(fn) {
    var prev = $197cd56b15c33885$var$game.getState();
    fn();
    $197cd56b15c33885$var$render(prev);
    $197cd56b15c33885$var$updateBest();
}
function $197cd56b15c33885$var$updateBest() {
    var best = $197cd56b15c33885$var$getBest();
    var current = $197cd56b15c33885$var$game.getScore();
    if (current > best) {
        $197cd56b15c33885$var$setBest(current);
        $197cd56b15c33885$var$bestScoreEl.textContent = current;
    }
}
/* START / RESTART */ $197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$render();
    $197cd56b15c33885$var$updateBest();
});
/* KEYBOARD */ document.addEventListener("keydown", function(e) {
    var actions = {
        ArrowLeft: function() {
            return $197cd56b15c33885$var$handleMove(function() {
                return $197cd56b15c33885$var$game.moveLeft();
            });
        },
        ArrowRight: function() {
            return $197cd56b15c33885$var$handleMove(function() {
                return $197cd56b15c33885$var$game.moveRight();
            });
        },
        ArrowUp: function() {
            return $197cd56b15c33885$var$handleMove(function() {
                return $197cd56b15c33885$var$game.moveUp();
            });
        },
        ArrowDown: function() {
            return $197cd56b15c33885$var$handleMove(function() {
                return $197cd56b15c33885$var$game.moveDown();
            });
        }
    };
    if (actions[e.key]) actions[e.key]();
});
/* INITIAL */ $197cd56b15c33885$var$render();
$197cd56b15c33885$var$bestScoreEl.textContent = $197cd56b15c33885$var$getBest();

})();
//# sourceMappingURL=index.d6bac365.js.map
